// extracted by mini-css-extract-plugin
export var content = "_4e-3";
export var list = "_4e-4";
export var settingsContent = "_4e-7";
export var settingsPanel = "_4e-8";
export var state = "_4e-6";
export var triggerBadge = "_4e-2";
export var triggerButton = "_4e-1";
export var triggerShell = "_4e-0";
export var unreadDot = "_4e-5";